import { render, staticRenderFns } from "./Scene6.vue?vue&type=template&id=52b7f9cb&"
import script from "./Scene6.vue?vue&type=script&lang=js&"
export * from "./Scene6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports